<div class="">
  <app-employment-history-list 
  [workerId]="workerId" 
  [isLoggedUserProfile]="isLoggedUserProfile" 
  [workerFormContext]="true"
  (employmentHistoryChange)="onEmploymentHistoryChanged($event)">
</app-employment-history-list>

  <br />
  <div class="header-wrapper"></div>
  <div fxLayout="row" fxLayoutAlign="space-between center" class="mt-20">
    <button mat-raised-button color="accent" matStepperPrevious>
      <mat-icon>arrow_back</mat-icon>
      {{ 'Back' | translate }}
    </button>
    <button mat-raised-button color="primary" matStepperNext [disabled]="isNextButtonDisabled" (click)="submitAndContinue()">
      {{ 'Next' | translate }}
    </button>
  </div>
</div>
